import script from "./HexBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./HexBadge.vue?vue&type=script&setup=true&lang=ts"

import "./HexBadge.vue?vue&type=style&index=0&id=53b14596&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53b14596"]])

export default __exports__